// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import { type AnnouncementProps } from './Announcement'

const consoleURL: any = process.env.CONSOLE_URL

interface SiteAnnouncements {
  deepseek: AnnouncementProps
  gaudi3xeon6: AnnouncementProps
}

const Announcements: SiteAnnouncements = {
  deepseek: {
    title: 'DeepSeek R1 is now available on Intel® Tiber™ AI Cloud',
    text: 'Run DeepSeek-R1-Distill-Llama-70B using text-generation-inference with Intel® Data Center GPU Max Series.',
    action: {
      label: 'Learn now',
      redirectTo: `${consoleURL}docs/tutorials/deepseek_r1.html`
    }
  },
  gaudi3xeon6: {
    title: 'Intel® Gaudi® 3 AI Accelerators and Intel® Xeon® 6 Processors are now available!',
    text: 'Xeon® 6 compute instances are available in our hardware catalog. Early access to Gaudi® 3 accelerators is coming soon.',
    action: {
      label: 'View our catalog',
      redirectTo: `${consoleURL}hardware?fctg=All`
    }
  }
}

export default Announcements
